export enum EDialogOpenMode {
    NEW = 'New',
    EDIT = 'Edit',
    CLONE = 'Clone',
    READ_ONLY = 'Read Only',
    REVERT = 'Revert'
}
